export default __webpack_public_path__ + "static/8-types-of-people-you-meet-hero-image-fc6187cd55cde40ede51cf8b4a7787af.jpg";